
import React from "react";
import { Modal, Button } from "react-bootstrap";

// example images (replace with your imports or public paths)
import ShareIcon from "../assets/Share.png";
import ModalLogo from "../assets/Modal-logo-img.png";
import ContactInfo from "../assets/contactInfo.png";
import Suitcase from "../assets/Suitcase.png";
import Travel from "../assets/trevel-s.png";
import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next'

const FlightDetailsModal = ({ show, handleClose }) => {
    const { t } = useTranslation();
  return (
    <Modal
    show={show}
    onHide={handleClose}
    centered
    className="ticket-details-modal-sec"
  >
    <Modal.Header closeButton>
      <div className="left-details">
        <h2>{t("flightTitle")}</h2>
        <Link
          to="#"
          className="link-text text-blue d-flex align-items-center gap-2"
        >
          <img src={ShareIcon} alt="share" />
          {t("shareFlight")}
        </Link>
      </div>
    </Modal.Header>

    <Modal.Body>
      <div className="ticked-modal-body">
        <div className="top-modal-box d-flex align-items-center gap-2">
          <div className="img-txet-box d-flex align-items-center gap-2">
            <div className="img">
              <img src={ModalLogo} alt="Airline Logo" />
            </div>
            <div className="text">
              <p className="mb-2">
                <strong>{t("route")}</strong>
              </p>
              <p>{t("schedule")}</p>
              <p>{t("directInfo")}</p>
              <p>{t("airlineInfo")}</p>
            </div>
          </div>
          <div className="btn-box">
            <Link to="#" className="link-text text-blue">
              {t("viewFlightDetails")}
            </Link>
          </div>
        </div>

        <div className="bottom-modal-ticket d-flex flex-wrap">
          <div className="left-box">
            <div className="left-ticket-bottom">
              <h4 className="mb-2">{t("baggage")}</h4>
              <p>{t("baggageInfo")}</p>
            </div>
          </div>
          <div className="right-box">
            <div className="right-ticket-bottom">
              <div className="com-details-list d-flex align-items-center gap-2 mb-2">
                <div className="icons">
                  <img src={ContactInfo} alt="icon" />
                </div>
                <div className="text">
                  <p>{t("personalItem")}</p>
                  <span className="text-green">{t("included")}</span>
                  <p>{t("personalItemInfo")}</p>
                </div>
              </div>
              <div className="com-details-list d-flex align-items-center gap-2 mb-2">
                <div className="icons">
                  <img src={Suitcase} alt="suitcase" />
                </div>
                <div className="text">
                  <p>{t("carryOn")}</p>
                  <span className="text-green">{t("included")}</span>
                  <p> {t("carryOnInfo")} </p>
                </div>
              </div>
              <div className="com-details-list d-flex align-items-center gap-2 mb-0">
                <div className="icons">
                  <img src={Travel} alt="travel" />
                </div>
                <div className="text">
                  <p>{t("checkedBag")}</p>
                  <span className="text-green">{t("included")}</span>
                  <p> {t("checkedBagInfo")} </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ✅ Currency auto-change */}
        <div className="amount-modal-box">
          <ul className="list-unstyled p-0 m-0 d-flex justify-content-between gap-2 align-items-center">
            <li className="dis-price-box">
              {t("total")} <span className="d-block">{t("taxInfo")}</span>
            </li>
            <li className="price-box">{t("INR")}8,883.27</li>
          </ul>
        </div>
      </div>
    </Modal.Body>

    <Modal.Footer>
      <Button variant="primary">{t("select")}</Button>
    </Modal.Footer>
  </Modal>
  );
};

export default FlightDetailsModal;
